module.exports = __webpack_public_path__ + "img/6-4.a42b4d93.png";